<template>
  <div>
    <div class="search-bar">
      <button class="search-button" @click="searchMovie(query)" name="Search" v-html="searchIcon"></button>
      <input class="search-input" type="text" @keyup.enter="searchMovie(query)" ref="search" v-model="query" placeholder="Type a movie title..." autofocus>
      <button class="clear-search-button" @click="clearQuery" name="Clear search" v-html="clearSearchIcon"></button>
    </div>
  </div>
</template>

<script>
import feather from 'feather-icons';

export default {
  data() {
    return {
      query: null,
      searchIcon: feather.icons.search.toSvg(),
      clearSearchIcon: feather.icons.x.toSvg(),
    };
  },
  methods: {
    searchMovie(query) {
      if (query) {
        this.$store.dispatch('searchMovie', query);
        this.$store.dispatch('removeRecommendedMovies');
        this.$store.dispatch('disableIntro');
      }
    },
    clearQuery() {
      this.query = '';
      this.$refs.search.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
  .search-bar {
    display: inline-flex;
    width: 100%;
    border-radius: 6px;
    background-color: white;
    box-shadow: $shadow-level-2;
  }

  .search-input {
    width: 100%;
    background-color: transparent;
    font-size: 20px;
    padding: 15px;
    border: none;
  }

  .search-button {
    display: flex;
    font-size: 2em;
    margin-left: 15px;
    color: $primary-color;
    background-color: transparent;
    transition: transform 0.4s;

    @media (min-width: $md) {
      &:hover {
        transform: scale(1.1);
      }
    }
  }

  .clear-search-button {
    display: flex;
    font-size: 2em;
    margin-right: 15px;
    color: $primary-color;
    background-color: transparent;
    transition: transform 0.4s;

    @media (min-width: $md) {
      &:hover {
        transform: rotate(180deg) scale(1.1);
      }
    }
  }
</style>
